let sine_1024: Float32Array | undefined;
let sine_128: Float32Array | undefined;


export function get_sine_1024() {
  if (sine_1024 === undefined) {
    sine_1024 = generate_sine_window(1024);
  }
  return sine_1024;
}


export function get_sine_128() {
  if (sine_128 === undefined) {
    sine_128 = generate_sine_window(128);
  }
  return sine_128;
}


function generate_sine_window(length: number): Float32Array {
  const values = new Float32Array(length);
  for (let i = 0; i < length; i++) {
    values[i] = Math.sin((i + 0.5) * (Math.PI / (2.0 * length)));
  }
  return values;
}


let kaiser_bessel_1024: Float32Array | undefined;
let kaiser_bessel_128: Float32Array | undefined;

export function get_kaiser_bessel_1024() {
  if (kaiser_bessel_1024 === undefined) {
    kaiser_bessel_1024 = generate_kaiser_bessel_window(4, 1024);
  }
  return kaiser_bessel_1024;
}


export function get_kaiser_bessel_128() {
  if (kaiser_bessel_128 === undefined) {
    kaiser_bessel_128 = generate_kaiser_bessel_window(6, 128);
  }
  return kaiser_bessel_128;
}


function generate_kaiser_bessel_window(alpha: number, length: number): Float32Array {
  const PIN = Math.PI / length;
  let sum = 0;
  const alpha2 = (alpha * PIN) * (alpha * PIN);

  const out = new Float32Array(length);
  const f = new Float32Array(length);

  for (let n = 0; n < length; n++) {
    const tmp = n * (length - n) * alpha2;
    let bessel = 1;

    for (let j = 50; j > 0; j--) {
      bessel = bessel * tmp / (j * j) + 1;
    }

    sum += bessel;
    f[n] = sum;
  }

  sum++;

  for (let n = 0; n < length; n++) {
    out[n] = Math.sqrt(f[n]! / sum);
  }

  return out;
}
